import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useButtonWidth } from '@services/layout'
import { setDanceOnAddProcess } from '@state/actions/dances'
import { setSaveFromReAkumSearch } from '@state/actions/dances'
import * as Utils from '@services/utils'
import urlUtils from '@services/urlUtils'
import TextInput from '@components/Form/TextInput'
import StaticLabeledText from '@components/Form/StaticLabeledText'
import FilterBox from '@components/Table/FilterBox'
import SubmitButton from '@components/Buttons/SubmitButton'
import CancelButton from '@components/AddEditDance/CancelButton'
import { setVersions, setSongs } from '@state/actions/songs'
import ArtistAutoCompleteInput from '@components/AddEditDance/ArtistAutoCompleteInput'
import {
    PageSubTitle,
    TextBtn,
    FormRow,
    FormWrapper,
    SubmitButtonsRow,
    SubmitBtnContainer,
    FormSection,
    ErrorText,
} from '@appearance/styled'
import { defaultDance } from '@services/dances'
import {
    DANCE_STATUS_ORDERED,
    DANCE_STATUS_APPROVED,
    DANCE_STATUS_EXISTS,
} from '@components/AddEditDance/StatusProgressButton'
import i18n from '@localization/i18n'

let composerIsEditable = false
let lyricistIsEditable = false

const getSelectedLyricists = (dance) => {
    let selectedFilters = []
    const lyricistsText = dance?.song?.lyricist
    let lyricistsArray = lyricistsText?.split(',')
    if (lyricistsArray?.length > 1) {
        lyricistsArray.map((lyricist) => {
            const cleanLyricistText = lyricist.trim()
            selectedFilters.push({
                label: cleanLyricistText,
                value: cleanLyricistText,
            })
        })
    } else {
        return dance.song.lyricist
            ? {
                  lyricist: [
                      Object.assign({
                          label: dance.song.lyricist.trim(),
                          value: dance.song.lyricist.trim(),
                      }),
                  ],
              }
            : {}
    }
    return { lyricist: selectedFilters }
}

const getSelectedComposers = (dance) => {
    let selectedFilters = []
    const composersText = dance?.song?.composer
    let composersArray = composersText?.split(',')
    if (composersArray?.length > 1) {
        composersArray.map((composer) => {
            const cleanComposerText = composer.trim()
            selectedFilters.push({
                label: cleanComposerText,
                value: cleanComposerText,
            })
        })
    } else {
        return dance.song.composer
            ? {
                  composer: [
                      Object.assign({
                          label: dance.song.composer.trim(),
                          value: dance.song.composer.trim(),
                      }),
                  ],
              }
            : {}
    }
    return { composer: selectedFilters }
}

const getSelectedPerformers = (dance) => {
    let selectedFilters = []
    const performersText = dance?.performer
    let performersArray = performersText?.split(',')
    if (performersArray?.length > 1) {
        performersArray.map((performer) => {
            const cleanPerformerText = performer.trim()
            selectedFilters.push({
                label: cleanPerformerText,
                value: cleanPerformerText,
            })
        })
    } else {
        console.log('Got in ELSE')
        return dance.performer
            ? {
                  performer: [
                      Object.assign({
                          label: dance.performer.trim(),
                          value: dance.performer.trim(),
                      }),
                  ],
              }
            : {}
    }
    return { performer: selectedFilters }
}

const getHebName = (arr) => {
    if (!arr) return null
    let artistsHebNames = ''
    arr.map((artist, i) => {
        if (artist['heb_name']) {
            artistsHebNames += artist['heb_name']
        }
        if (i + 1 !== arr.length) {
            artistsHebNames += ', '
        }
    })
    return artistsHebNames
}

export default ({
    user,
    dance,
    updateSong,
    updateSongAndDanceName,
    setDanceProperty,
    checkPermissionByField,
}) => {
    const getTempArtistsNames = (fieldName) => {
        return getHebName(dance.song[fieldName])
            ? {
                  [fieldName.slice(0, -1)]: [
                      {
                          value: getHebName(dance.song[fieldName]),
                          label: getHebName(dance.song[fieldName]),
                      },
                  ],
              }
            : null
    }

    const [selectedLyricistsFilters, setSelectedLyricistsFilters] = useState(
        getTempArtistsNames('lyricists') || getSelectedLyricists(dance)
    )

    const [selectedComposersFilters, setSelectedComposersFilters] = useState(
        getTempArtistsNames('composers') || getSelectedComposers(dance)
    )
    const [selectedPerformersFilters, setSelectedPerformersFilters] = useState(
        getSelectedPerformers(dance)
    )
    //console.log('12345678', getSelectedPerformers(dance))
    const extractPerformersString = (newFilters) => {
        let res = ''
        const performersArray = newFilters?.performer
        if (performersArray) {
            performersArray.map((performer) => {
                res += performer.value + ', '
            })
        }
        res = res.slice(0, -2)
        return res
    }

    const updatePerformersFilters = (name, selected) => {
        const newFilters = Object.assign({}, selectedPerformersFilters)

        if (selected && selected.length > 0) {
            newFilters[name] = selected.map((sel) => sel)
        } else {
            if (newFilters[name]) {
                delete newFilters[name]
            }
        }
        setSelectedPerformersFilters(newFilters)
        // setSongProperty({
        //     performer: extractPerformersString(newFilters),
        // })
        setDanceProperty({
            performer: extractPerformersString(newFilters),
        })
    }

    const extractComposersString = (newFilters) => {
        let res = ''
        const composersArray = newFilters?.composer
        if (composersArray) {
            composersArray.map((composer) => {
                res += composer.value + ', '
            })
        }
        res = res.slice(0, -2)
        return res
    }

    const updateComposersFilters = (name, selected) => {
        const newFilters = Object.assign({}, selectedComposersFilters)

        if (selected && selected.length > 0) {
            newFilters[name] = selected.map((sel) => sel)
        } else {
            if (newFilters[name]) {
                delete newFilters[name]
            }
        }
        setSelectedComposersFilters(newFilters)
        setSongProperty({
            composer: extractComposersString(newFilters),
        })
        if (
            !newFilters ||
            newFilters === {} ||
            Object.keys(newFilters).length === 0
        ) {
            setSongProperty({
                composers: '',
            })
        }
    }

    const extractLyricistsString = (newFilters) => {
        let res = ''
        const lyricistsArray = newFilters?.lyricist
        if (lyricistsArray) {
            lyricistsArray.map((lyricist) => {
                res += lyricist.value + ', '
            })
        }
        res = res.slice(0, -2)
        return res
    }
    const updateLyricistsFilters = (name, selected) => {
        const newFilters = Object.assign({}, selectedLyricistsFilters)

        if (selected && selected.length > 0) {
            newFilters[name] = selected.map((sel) => sel)
        } else {
            if (newFilters[name]) {
                delete newFilters[name]
            }
        }
        setSelectedLyricistsFilters(newFilters)
        setSongProperty({
            lyricist: extractLyricistsString(newFilters),
        })
        if (
            !newFilters ||
            newFilters === {} ||
            Object.keys(newFilters).length === 0
        ) {
            setSongProperty({
                lyricists: '',
            })
        }
    }

    // console.log('FROM Song Details -- dance  = ', dance)
    let composers = dance.song.composers
    composers.length > 0
        ? (composerIsEditable = false)
        : (composerIsEditable = true)

    let lyricists = dance.song.lyricists
    lyricists.length > 0
        ? (lyricistIsEditable = false)
        : (lyricistIsEditable = true)

    const danceStatus = dance.status
    const [updateSongName, setUpdateSongName] = useState(dance.song.name)
    const [danceName, setDanceName] = useState(dance.name)
    const history = useHistory()
    const dispatch = useDispatch()
    const buttonWidth = useButtonWidth()
    const [updateAkumNumber, setUpdateAkumNumber] = useState(dance.song.akum_id)
    const [updateTranslatedVersionId, setUpdateTranslatedVersionId] = useState(
        dance.song.translated_version_id
    )

    const [showAkumSearch, setShowAkumSearch] = useState(
        !dance.status && !dance.song.akum_id
    )
    const [
        showAkumResearchTextButton,
        setShowAkumResearchTextButton,
    ] = useState(dance.song.akum_id && !danceStatus)

    const [showManualDetailsInputs, setShowManualDetailsInputs] = useState(
        dance.song.akum_id === 'not_found' && !danceStatus
    )

    const [showManualStaticFields, setShowManualStaticFields] = useState(
        danceStatus &&
            (dance.song.akum_id === 'not_found' ||
                (dance.status === DANCE_STATUS_EXISTS && !dance.song.akum_id))
    )

    const [showStaticAkumFields, setShowStaticAkumFields] = useState(false)

    const setSongProperty = (propertyObj) => {
        updateSong(Object.assign({}, dance.song, propertyObj))
    }

    useEffect(() => {
        if (!lyricistIsEditable) {
            setSongProperty({ lyricist: '' })
        }
        if (!composerIsEditable) {
            setSongProperty({ composer: '' })
        }
    }, [lyricistIsEditable, composerIsEditable])

    useEffect(() => {
        if (dance.song.akum_id) {
            setShowAkumSearch(false)
            if (!dance.status) {
                setShowAkumResearchTextButton(true)
                if (dance.song.akum_id === 'not_found') {
                    setShowManualDetailsInputs(true)
                }
            }
        }
    }, [dance])

    useEffect(() => {
        if (
            (dance.song.akum_id &&
                dance.song.akum_id !== 'not_found' &&
                dance.song.akum_id !== '') ||
            (!showAkumSearch &&
                !showManualDetailsInputs &&
                !showAkumResearchTextButton)
        )
            setShowStaticAkumFields(true)
    }, [dance.song.akum_id])

    useEffect(() => {
        if (user && user.is_admin) {
            if (dance.song.akum_id === 'not_found' && dance.performer === '') {
                setShowManualDetailsInputs(true)
                setShowManualStaticFields(false)
            }
        }
    }, [user])

    useEffect(() => {
        if (lyricistIsEditable || composerIsEditable) {
            setShowManualStaticFields(false)
        }
    }, [])
    // useEffect(() => {
    //     if (dance && !dance.status) {
    //         const name = dance.song.name
    //         setDanceProperty({ name })
    //         setDanceName(name)
    //     }
    // }, [dance.song.name])

    const resetSong = () =>
        setSongProperty({
            akum_id: '',
            composer: '',
            lyricist: '',
            performer: '',
            composers: [],
            lyricists: [],
        })

    const akumResearchTextLinkClick = () => {
        resetSong()
        setShowAkumSearch(true)
        setShowManualDetailsInputs(false)
        setShowManualStaticFields(false)
        setShowStaticAkumFields(false)
        setShowAkumResearchTextButton(false)
    }

    const goToAcumSearch = () => {
        dance?.status
            ? dispatch(setSaveFromReAkumSearch(true))
            : dispatch(setSaveFromReAkumSearch(null))
        dispatch(setDanceOnAddProcess(dance))
        dispatch(setSongs(null))
        dispatch(setVersions(null))
        history.push({
            pathname: 'acum_search_song',
            search: urlUtils.buildQueryParams({
                ...urlUtils.getQueryParams(),
                song: dance.song.name,
                page: 1,
            }),
        })
    }

    if (!dance.song) {
        return null
    }

    const disableAkumSearch = dance?.song?.name?.length < 3
    const allowSongDetailsEdit =
        !dance.status || dance.status === DANCE_STATUS_ORDERED || user?.is_admin

    return (
        <FormWrapper>
            {showAkumSearch && (
                <FormSection>
                    <FormRow>
                        <TextInput
                            text={dance.song.name}
                            onChangeText={updateSongAndDanceName}
                            width={'100%'}
                            required={true}
                            label={i18n.t('edit_dance.song_name')}
                        />
                        <Flex1 />
                    </FormRow>
                    <FormRow>
                        {disableAkumSearch && (
                            <ErrorText>
                                {i18n.t(
                                    'edit_dance.minimum_search_length_error'
                                )}
                            </ErrorText>
                        )}
                    </FormRow>
                    <SubmitButtonsRow>
                        <StyledSubmitBtnContainer>
                            <SubmitButton
                                onClick={goToAcumSearch}
                                label={i18n.t('edit_dance.search_song_in_akum')}
                                disabled={disableAkumSearch}
                            />
                        </StyledSubmitBtnContainer>
                        <StyledSubmitBtnContainer>
                            <CancelButton
                                label={
                                    dance.id
                                        ? i18n.t('edit_dance.cancel_edit')
                                        : i18n.t('edit_dance.canael_order')
                                }
                                goToDancesSecreen={true}
                            />
                        </StyledSubmitBtnContainer>
                    </SubmitButtonsRow>
                </FormSection>
            )}

            {showStaticAkumFields && (
                //  || user?.is_admin
                <FormWrapper>
                    <FormRow>
                        {checkPermissionByField() ? (
                            <TextInput
                                text={danceName || dance.name}
                                label={i18n.t(
                                    'edit_dance.dance_name_changeable'
                                )}
                                required={true}
                                onChangeText={(name) => {
                                    setDanceProperty({ name })
                                    setDanceName(name)
                                }}
                            />
                        ) : (
                            <StaticLabeledText
                                text={danceName || dance.name}
                                label={'שם ריקוד'}
                                width={'initial'}
                            />
                        )}
                        {user?.is_admin && (
                            <NewSearchBtnContainer>
                                <SubmitButton
                                    onClick={goToAcumSearch}
                                    label={i18n.t(
                                        'edit_dance.perform_new_akum_search'
                                    )}
                                    disabled={disableAkumSearch}
                                />
                            </NewSearchBtnContainer>
                        )}
                    </FormRow>
                    <FormRow>
                        {user?.is_admin ? (
                            <TextInput
                                text={updateSongName || dance.song.name}
                                label={i18n.t('edit_dance.original_song_name')}
                                required={true}
                                onChangeText={(name) => {
                                    setSongProperty({ name })
                                    setUpdateSongName(name)
                                }}
                            />
                        ) : (
                            <StaticLabeledText
                                text={dance.song.name}
                                label={i18n.t('edit_dance.original_song_name')}
                                width={buttonWidth}
                            />
                        )}

                        {user?.is_admin ? (
                            <TextInput
                                text={dance.song.akum_id || updateAkumNumber}
                                label={i18n.t('edit_dance.akum_id')}
                                width={'initial'}
                                onChangeText={(akum_id) => {
                                    setUpdateAkumNumber(akum_id)
                                    setSongProperty({ akum_id })
                                }}
                            />
                        ) : (
                            <StaticLabeledText
                                text={dance.song.akum_id}
                                label={i18n.t('edit_dance.akum_id')}
                                width={buttonWidth}
                            />
                        )}
                    </FormRow>
                    <FormRow>
                        {user?.is_admin ? (
                            <TextInput
                                text={
                                    updateTranslatedVersionId ||
                                    dance.song.translated_version_id
                                }
                                label={i18n.t(
                                    'edit_dance.translated_version_id'
                                )}
                                width={'initial'}
                                onChangeText={(translated_version_id) => {
                                    setUpdateTranslatedVersionId(
                                        translated_version_id
                                    )
                                    setSongProperty({ translated_version_id })
                                }}
                            />
                        ) : dance.song.translated_version_id ? (
                            <StaticLabeledText
                                text={dance.song.translated_version_id}
                                label={i18n.t(
                                    'edit_dance.translated_version_id'
                                )}
                                width={'initial'}
                            />
                        ) : null}

                        {dance.song.publication_year ? (
                            <StaticLabeledText
                                text={dance.song.publication_year}
                                label={i18n.t(
                                    'edit_dance.song_publication_year'
                                )}
                                width={'initial'}
                            />
                        ) : null}
                    </FormRow>

                    <FormRow>
                        {checkPermissionByField('performer') ? (
                            <TextInput
                                label={i18n.t('edit_dance.performer')}
                                text={dance.performer}
                                onChangeText={(performer) => {
                                    setDanceProperty({ performer })
                                }}
                                width={buttonWidth}
                                required={true}
                            />
                        ) : (
                            <StaticLabeledText
                                text={dance.performer}
                                label={i18n.t('edit_dance.performer')}
                                width={'initial'}
                            />
                        )}
                        {composerIsEditable ||
                        (user?.is_admin &&
                            (!dance?.song.akum_id ||
                                dance.akum_id?.song.length < 1)) ? (
                            allowSongDetailsEdit ? (
                                <FilterBox
                                    filter={{
                                        property: 'composer',
                                        label: i18n.t('edit_dance.composer'),
                                    }}
                                    updateFilters={updateComposersFilters}
                                    selectedFilters={selectedComposersFilters}
                                    collection={'dances'}
                                    required={true}
                                    optionsRequired={true}
                                    optionsMsg={' (הוסף חדש)'}
                                />
                            ) : (
                                <StaticLabeledText
                                    text={dance.song.composer}
                                    label={i18n.t('edit_dance.composer')}
                                    width={'initial'}
                                    required={true}
                                />
                            )
                        ) : (
                            <StaticLabeledText
                                text={getHebName(dance.song.composers)}
                                label={i18n.t('edit_dance.composer')}
                                width={'initial'}
                                required={true}
                            />
                        )}
                        {lyricistIsEditable ||
                        (user?.is_admin &&
                            (!dance?.song.akum_id ||
                                dance?.song?.akum_id?.length < 1)) ? (
                            allowSongDetailsEdit ? (
                                <FilterBox
                                    filter={{
                                        property: 'lyricist',
                                        label: i18n.t('edit_dance.lyricist'),
                                    }}
                                    updateFilters={updateLyricistsFilters}
                                    selectedFilters={selectedLyricistsFilters}
                                    collection={'dances'}
                                    required={true}
                                    optionsRequired={true}
                                    optionsMsg={' (הוסף חדש)'}
                                />
                            ) : (
                                <StaticLabeledText
                                    text={dance.song.lyricist}
                                    label={i18n.t('edit_dance.lyricist')}
                                    width={'initial'}
                                    required={true}
                                />
                            )
                        ) : (
                            <StaticLabeledText
                                text={getHebName(dance.song.lyricists)}
                                label={i18n.t('edit_dance.lyricist')}
                                width={'initial'}
                                required={true}
                            />
                        )}
                    </FormRow>
                </FormWrapper>
            )}
            {showAkumResearchTextButton && (
                <FormWrapper>
                    <PageSubTitle>
                        {showManualDetailsInputs &&
                            i18n.t('edit_dance.manual_registration_request')}
                        <TextBtn onClick={akumResearchTextLinkClick}>
                            {' '}
                            {i18n.t('edit_dance.perform_new_search')}
                        </TextBtn>
                    </PageSubTitle>
                </FormWrapper>
            )}

            {showManualDetailsInputs && (
                <FormWrapper>
                    <FormRow>
                        <TextInput
                            text={dance.name}
                            label={i18n.t('edit_dance.original_song_name')}
                            onChangeText={updateSongAndDanceName}
                            width={'100%'}
                            required={true}
                        />
                        <Flex2 />
                    </FormRow>
                    <FormRow>
                        <FilterBox
                            filter={{
                                property: 'performer',
                                label: i18n.t('edit_dance.performer'),
                            }}
                            updateFilters={updatePerformersFilters}
                            selectedFilters={selectedPerformersFilters}
                            collection={'dances'}
                            required={true}
                            optionsRequired={true}
                            optionsMsg={' (הוסף חדש)'}
                        />
                        <FilterBox
                            filter={{
                                property: 'composer',
                                label: i18n.t('edit_dance.composer'),
                            }}
                            updateFilters={updateComposersFilters}
                            selectedFilters={selectedComposersFilters}
                            collection={'dances'}
                            required={true}
                            optionsRequired={true}
                            optionsMsg={' (הוסף חדש)'}
                        />

                        <FilterBox
                            filter={{
                                property: 'lyricist',
                                label: i18n.t('edit_dance.lyricist'),
                            }}
                            updateFilters={updateLyricistsFilters}
                            selectedFilters={selectedLyricistsFilters}
                            collection={'dances'}
                            required={true}
                            optionsRequired={true}
                            optionsMsg={' (הוסף חדש)'}
                        />
                    </FormRow>
                </FormWrapper>
            )}
        </FormWrapper>
    )
}

const Flex1 = styled.div`
    flex: 1;
    padding: 0 20px;
`
const Flex2 = styled.div`
    flex: 2;
    padding: 0 40px;
`
export const FullWidthContainer = styled.div``

const StyledSubmitBtnContainer = styled(SubmitBtnContainer)`
    margin-bottom: 0px;
`

const NewSearchBtnContainer = styled(SubmitBtnContainer)`
    margin-top: 35px;
`
